import ArticleLayout from "../components/ArticleLayout";

export default function TshirtsGuide() {
  return <ArticleLayout articleId={8} />;
}